import React, { useState } from 'react';
import { Truck } from 'lucide-react';
import { CARRIER_LABELS } from '../../constants/shipments';
import { shipmentsApi } from '../../utils/shipmentsApi';
import { Banner } from './Ui';
import { useRemote } from './useRemote';

// Carrier toggles (PATCH /carriers/:code). A switched-off carrier is not recognised in new e-mails.
const CarriersCard = ({ notify }) => {
  const carriers = useRemote('carriers', () => shipmentsApi.carriers());
  const [busy, setBusy] = useState('');
  const [error, setError] = useState('');
  const items = carriers.data || [];

  const toggle = async (c) => {
    setBusy(c.code);
    setError('');
    try {
      await shipmentsApi.setCarrierActive(c.code, !c.isActive);
      carriers.mutate((list) => (list || []).map((x) => (x.code === c.code ? { ...x, isActive: !c.isActive } : x)));
      notify.success(`${c.name || CARRIER_LABELS[c.code] || c.code}: ${c.isActive ? 'vypnuto' : 'zapnuto'}.`);
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy('');
    }
  };

  return (
    <section className="shp-card" aria-labelledby="shp-carriers-title">
      <h2 id="shp-carriers-title" className="shp-h2"><Truck size={18} color="#E53935" aria-hidden="true" /> Dopravci</h2>
      <p className="shp-muted shp-small" style={{ margin: '0 0 12px' }}>Vypnutý dopravce se v nových e-mailech nerozpoznává a nenabízí se ve filtrech. Už uložené zásilky zůstanou.</p>
      {carriers.error && <Banner tone="bad">Dopravce se nepodařilo načíst. {carriers.error.message}</Banner>}
      {error && <Banner tone="bad">{error}</Banner>}
      <ul style={{ listStyle: 'none', margin: 0, padding: 0, display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: 8 }}>
        {items.map((c) => (
          <li key={c.code} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, border: '1px solid #E0E0E0', borderRadius: 10, padding: '4px 6px 4px 12px' }}>
            <span className="shp-wrap" style={{ fontSize: 14 }}>{c.name || CARRIER_LABELS[c.code] || c.code}<span className="shp-sr">{c.isActive ? ' (zapnuto)' : ' (vypnuto)'}</span></span>
            <span className="shp-switchbox">
              <button type="button" role="switch" aria-checked={c.isActive} className="shp-switch" disabled={busy === c.code}
                aria-label={`Dopravce ${c.name || c.code}`} onClick={() => toggle(c)} />
            </span>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default CarriersCard;
